module.exports = "/fonts/nucleo-icons.woff2?69d4ebfdc94eab6fdb6e23934edd6c89";